"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = require("styled-components");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _default(props) {
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);
  return /*#__PURE__*/_react["default"].createElement("svg", Object.assign({}, props, {
    width: "7",
    height: "14",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 9 16"
  }), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(-18 -16)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    stroke: themeContext.colors.primary['90'],
    strokeWidth: "1.6",
    d: "M26.4 16.8L19.2 24l7.2 7.2"
  }))));
}
//# sourceMappingURL=ArrowLeft.js.map